export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10571.069ffa30.jpg";